<template>
    <div class="w-100">
        <b-form-input
            type="text"
            :id="id"
            :value="value"
            @input="val => $emit('input', val)"
            :debounce-events="'blur'"
            v-debounce:200ms="onBlur"
            :placeholder="placeholder"
            autocomplete="off"
        />
        <b-list-group class="autocomplete px-3">
            <b-list-group-item class="border-0 text-center" v-if="loading">
                <b-spinner variant="secondary" type="grow" small/>
            </b-list-group-item>
            <b-list-group-item
                v-else-if="showOptions"
                v-for="(option, index) in filteredOptions"
                :key="index"
                button
                class="autocomplete-item py-2"
                :class="index < filteredOptions.length - 1 ? 'border-bottom' : ''"
                @click="onOptionSelect(option)"
            >
                {{ optionText(option) }}
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
export default {
    name: "AutocompleteInput",
    props: {
        id: String,
        value: String,
        placeholder: String,
        loading: Boolean,
        options: Array,
        valueField: String,
        textField: String,
        minCharacters: {
            type: Number,
            default: 0
        },
        serverFilter: Boolean
    },
    data(){
        return {
            showOptions: false
        }
    },
    methods:{
        onOptionSelect(option){
            const value = this.valueField ? option[this.valueField] : option.value
            this.$emit('select', value);
            this.showOptions = false;
        },
        onBlur(){
            this.showOptions = false;
        },
        optionText(option){
            return this.textField ? option[this.textField] : option.text
        }
    },
    watch:{
        trimmedInput(){
            this.showOptions = this.trimmedInput.length > this.minCharacters;
        },
        options(){
            this.showOptions = this.options && this.options.length > 0;
        },
    },
    computed:{
        trimmedInput(){
            return this.value.split(' ').join('');
        },
        filteredOptions(){
            if(this.serverFilter) return this.options;
            
            return this.options.filter(option => {
                return this.optionText(option).toLowerCase().includes(this.trimmedInput.toLowerCase())
            })
        }
    }
}
</script>

<style scoped lang="scss">
.autocomplete{
    z-index: 999;
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;

    &-item{
        padding-left: 0.75rem;
        border: 0;
    }
}
</style>